import { render, staticRenderFns } from "./SubTitle.vue?vue&type=template&id=fccac72a&scoped=true&"
import script from "./SubTitle.vue?vue&type=script&lang=js&"
export * from "./SubTitle.vue?vue&type=script&lang=js&"
import style0 from "./SubTitle.vue?vue&type=style&index=0&id=fccac72a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccac72a",
  null
  
)

export default component.exports